import React from "react";
import WaypointExpIcon from "../../../Icons/WaypointExpIcon";
import { Hotspot, Popup, Scene, TourData } from "../../../../Types";
import { useMockEscapeRoomStore } from "../../escape-room/zustand";
import { getLanguageFile } from "../../../common/GetLanguageFile";
import { useCurrentSceneStore } from "../../../../api/Zustand";
import { useViewerPopupStore } from "../../../../state management/zustand/viewer-stores";

function ViewerWaypoint(props: {
  waypoint: Hotspot;
  tourData: TourData;
  zoom: number;
}) {
  const { waypoint, tourData, zoom } = props;

  const { hardLockQuestions, softLockQuestions } = useMockEscapeRoomStore();

  const { setCurrentSceneID } = useCurrentSceneStore();

  const targetScene = React.useMemo(() => {
    return tourData.scenes.find((one: Scene) => one.id === waypoint.target);
  }, [tourData.scenes, waypoint.target]);

  const direction = React.useMemo(() => {
    switch (waypoint.dir) {
      case "L":
        return 180;
      case "B":
        return 90;
      case "T":
        return -90;
      default:
        return 0;
    }
  }, [waypoint.dir]);

  return (
    <div
      tooltip-text={
        targetScene?.title || getLanguageFile("viewer.scene_deleted")
      }
      className="viewer-exp-icon"
    >
      <WaypointExpIcon
        fill={targetScene ? "white" : "red"}
        stroke={"#222"}
        strokeWidth="3px"
        width="3.6em"
        height="3.6em"
        style={{
          transform: `rotate(${direction}deg)`,
          opacity: ((zoom - 15) * 100) / 76 <= 30 ? 0.3 : 1,
        }}
        onClick={() => navigateWithLocksCheck(targetScene?.id as number)}
      />
    </div>
  );
}

export default ViewerWaypoint;

export function navigateWithLocksCheck(id: number, callBack?: () => void) {
  return new Promise((resolve, reject) => {
    const { hardLockQuestions, softLockQuestions } =
      useMockEscapeRoomStore.getState();
    const { setCurrentSceneID, currentSceneID } =
      useCurrentSceneStore.getState();
    const { setOpen, setInnerJSX } = useViewerPopupStore.getState();

    if (currentSceneID === id) return;

    if (hardLockQuestions.length) {
      setOpen(0);
      setInnerJSX(<HardLockScreen />);
    } else if (softLockQuestions.length) {
      setOpen(0);
      setInnerJSX(<SoftLockScreen id={id} />);
    } else {
      setCurrentSceneID(id);
      resolve(() => {
        if (callBack) {
          callBack();
        }
      });
    }
  });
}

const SoftLockScreen = (props: { id: number }) => {
  const { setCurrentSceneID } = useCurrentSceneStore();
  const { setClose, setInnerJSX } = useViewerPopupStore();

  return (
    <div className="waypoint-lock">
      <p>{getLanguageFile("viewer.softlock")}</p>

      <fieldset>
        <button
          className="answer confirm"
          onClick={() => {
            setClose();
            setInnerJSX();
          }}
        >
          {getLanguageFile("generics.cancel")}
        </button>

        <button
          className="answer confirm"
          onClick={() => {
            setClose();
            setCurrentSceneID(props.id);
            setInnerJSX();
          }}
        >
          {getLanguageFile("generics.confirm")}
        </button>
      </fieldset>
    </div>
  );
};

const HardLockScreen = () => {
  const { setClose, setInnerJSX } = useViewerPopupStore();

  return (
    <div className="waypoint-lock">
      <p>{getLanguageFile("viewer.hardlock")}</p>

      <fieldset>
        <div className="placeholder"></div>
        <button
          className="answer confirm"
          onClick={() => {
            setClose();
            setInnerJSX();
          }}
        >
          {getLanguageFile("generics.cancel")}
        </button>
      </fieldset>
    </div>
  );
};
